import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Loading, SharingTables } from '../root/components/common'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { cloneDeep } from 'lodash'
import * as actions from './actions'
import { Table } from '../root/components/common/table'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    noUsersWrapper: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    link: {
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    sharingTables: {
        display: 'flex',
        height: '100%'
    },
    sharingTableWrapper: {
        flex: 5
    },
    sharingButtonsWrapper: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    moveToIcon: {
        color: theme.textPrimary
    },
    tableInfo: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    }
}))

function ChooseUsers(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const { isLoading, locale } = useSelector(state => state.main)
    const { selectedSharedUsers } = useSelector(state => state.sharing)
    const { sharedUsers, history } = props
    const [checkedInitialSharedUsers, setCheckedInitialSharedUsers] = useState({})
    const [checkedSelectedSharedUsers, setCheckedSelectedSharedUsers] = useState({})
    const [sharedUsersMutable, setSharedUsersMutable] = useState(sharedUsers ? cloneDeep(sharedUsers) : [])
    const [selectedSharedUsersMutable, setSelectedSharedUsersMutable] = useState(cloneDeep(selectedSharedUsers))

    const columns = [
        {
            key: 'name',
            label: locale.common.name,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        },
        {
            key: 'customer_name',
            label: locale.sharing.organisation,
            sortable: true,
            dataType: 'string',
            useCustomRenderer: false
        }
    ]

    const navigateToUserMgmt = () => {
        history.push('/user-management')
    }

    const setSharedUsersState = (data) => {
        dispatch(actions.sharedUsersSuccess(data))
        setCheckedInitialSharedUsers({})
        setCheckedSelectedSharedUsers({})
    }

    const setSelectedSharedUsersState = (data) => {
        dispatch(actions.setSelectedSharedUsers(data))
        setCheckedInitialSharedUsers({})
        setCheckedSelectedSharedUsers({})
    }

    useEffect(() => {
        if (sharedUsers) setSharedUsersMutable(cloneDeep(sharedUsers))
        setSelectedSharedUsersMutable(cloneDeep(selectedSharedUsers))
    }, [sharedUsers, selectedSharedUsers])

    return (
        <div className={classes.wrapper}>
            {isLoading &&
                <Loading/>
            }
            {!isLoading &&
                <React.Fragment>
                    {(!sharedUsersMutable || sharedUsersMutable.length === 0) && (!selectedSharedUsersMutable || selectedSharedUsersMutable.length === 0) &&
                        <div className={classes.noUsersWrapper}>
                            <div>
                                {locale.sharing.noUsersToShare}
                            </div>
                            <div>
                                <span>
                                    {locale.sharing.pleaseAddUsers}
                                </span>
                                <span className={classes.link} onClick={navigateToUserMgmt}>
                                    {` ${locale.sharing.userMgmt}`}
                                </span>
                            </div>
                        </div>
                    }
                    {((sharedUsersMutable && sharedUsersMutable.length > 0) || selectedSharedUsersMutable && selectedSharedUsersMutable.length > 0) &&
                        <SharingTables
                            leftData={sharedUsersMutable}
                            rightData={selectedSharedUsersMutable}
                            selectedLeftData={checkedInitialSharedUsers}
                            selectedRightData={checkedSelectedSharedUsers}
                            uniqueKey='id'
                            setLeftData={setSharedUsersState}
                            setRightData={setSelectedSharedUsersState}
                            leftTable={
                                (sharedUsersMutable && sharedUsersMutable.length > 0)
                                ? (
                                    <Table
                                        rows={sharedUsersMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedInitialSharedUsers}
                                        select={setCheckedInitialSharedUsers}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noUsersLeft}
                                    </div>
                                )
                            }
                            rightTable={
                                (selectedSharedUsersMutable && selectedSharedUsersMutable.length > 0)
                                ? (
                                    <Table
                                        rows={selectedSharedUsersMutable}
                                        columns={columns}
                                        multiselect
                                        selected={checkedSelectedSharedUsers}
                                        select={setCheckedSelectedSharedUsers}
                                    />
                                )
                                : (
                                    <div className={classes.tableInfo}>
                                        {locale.sharing.noUsersSelected}
                                    </div>
                                )
                            }
                        />
                    }
                </React.Fragment>
            }
        </div>
    )
}

export default withRouter(ChooseUsers)
